import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { EncryptionTypes } from "../../../constants/encryptionTypes";

interface SummaryProps {
    onBack: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Summary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values, isValid, errors } = useFormikContext<any>();
    console.log("Summary values:", isValid, " errors ", errors);
    return <div className="px-3 h-full relative">
        <h2 className="text-lg font-bold">{translate.byKey(TranslationKeys.details)}</h2>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.certType)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.alias)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.commonName)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.validFor)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.certificateTypeLabel}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.alias}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.commonName}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.validFor} {values.validityInLabel}</span>
            </div>
        </div>

        <h2 className="text-lg font-bold pt-3">{translate.byKey(TranslationKeys.encryption)}</h2>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.encryptionType)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(values.encryptionType === EncryptionTypes.RSA ? TranslationKeys.keySize : TranslationKeys.curve)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.algorithm)}:</span>
                {values.isCA ? <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.createAsCA)}:</span> : <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.certificateAuthority)}:</span>}
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.encryptionType}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.keyParameter}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.shaAlgorithm}</span>
                {values.isCA ? <span className="pt-1 text-sm text-black pl-2">{translate.byKey(TranslationKeys.yes)}</span> : <span className="pt-1 text-sm text-black pl-2">{values.certificateAuthorityLabel}</span>}
            </div>
        </div>

        <h2 className="text-lg font-bold pt-3">{translate.byKey(TranslationKeys.subjectAlternativeName)}</h2>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.domainNameSystem)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.internetProtocol)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.uniformResourceIdentifier)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.domainNameSystem.trim() ? values.domainNameSystem: translate.byKey(TranslationKeys.notApplicable)}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.internetProtocol.trim() ? values.internetProtocol : translate.byKey(TranslationKeys.notApplicable)}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.uniformResourceIdentifier.trim() ? values.uniformResourceIdentifier : translate.byKey(TranslationKeys.notApplicable)}</span>
            </div>
        </div>

        <div className="flex justify-end w-full absolute bottom-0 pr-3 pb-3 ">
            <button
                className={`py-1 px-5 mt-3 mr-2 text-portal-blue-primary-shade2`}
                type="button"
                onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            <button
                className={`py-1 px-5 mt-3 secondary text-white bg-lime`}
                type="submit">{translate.byKey(TranslationKeys.submit)}</button>
        </div>
    </div>
}

export default Summary;